import store from '../redux';

const SUPER_ADMIN = "super_admin";
const ADMIN       = "admin";
const USER        = "user";


const getUser = () => {
    return store.getState().auth.user;
}

export const isLoggedIn = () => {
    let user = getUser();
    return (user && ('id' in user));
}

export const isSuperAdmin = () => {
    return isLoggedIn() && getUser().role === SUPER_ADMIN;
}

export const isAdmin = () => {
    return isLoggedIn() && (
        isSuperAdmin() || getUser().role === ADMIN
    );
}

export const isUser = () => {
    return isLoggedIn() && (
        isAdmin() || getUser().role === USER
    )
}

// returns true if user has exactly this role
export const isRole = (role) => {
    return isLoggedIn() && getUser().role === role;
}

// returns true if user role allows him to have the given role
export const hasRole = (role) => {
    return isLoggedIn() && {
        [SUPER_ADMIN]: isSuperAdmin(),
        [ADMIN]: isAdmin(),
        [USER]: isUser()
    }[role];
}
